// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__34nMr","head":"Table_head__8V4LR","col":"Table_col__3NL7A"};